import { render, staticRenderFns } from "./EditCheckpointsTab.vue?vue&type=template&id=11a86f67&scoped=true"
import script from "./EditCheckpointsTab.vue?vue&type=script&lang=js"
export * from "./EditCheckpointsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a86f67",
  null
  
)

export default component.exports